import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import * as pako from 'pako';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { UserProfile } from '../../profile/models/userProfile.model';
import {
  AccessRule,
  Application,
  ApplicationDataStream,
  ApplicationGroup,
  NewRole,
} from '../models/authorizationService.model';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  protected authorizationBaseUrl = this.env.API_BASE_URL + '/service/authorization/';

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  static getDataFromClaims(str: string, atob: (input: string) => string) {
    const strData = atob(str);
    const charData = strData.split('').map((x) => x.charCodeAt(0));
    const binData = new Uint8Array(charData);
    return JSON.parse(pako.inflate(binData, { to: 'string' }));
  }

  getSearchProfiles(searchtext: string): Observable<UserProfile> {
    return this.http.get<UserProfile>(
      `${this.authorizationBaseUrl}secure/userprofile/email?Email=${searchtext}`,
    );
  }

  getApplications() {
    return this.http.get<Application[]>(`${this.authorizationBaseUrl}secure/access/application`);
  }

  getApplicationGroups() {
    return this.getGroups('Agrifirm');
  }

  getPartnerGroups() {
    return this.getGroups('Partner');
  }

  getUserAccess(profileId: number) {
    return this.http.get<AccessRule[]>(`${this.authorizationBaseUrl}secure/access/useraccess`, {
      params: { ProfileId: profileId.toString() },
    });
  }

  getDataStreamAccess(businessPartnerId: number) {
    console.log('hardcoded not ussing ' + businessPartnerId);
    return this.http.get<ApplicationDataStream[]>(
      `${this.authorizationBaseUrl}secure/access/applicationdatastream?EntityExternalId=1023258&System=OneSAP`,
    );
  }

  getRoles() {
    return this.http.get<NewRole[]>(`${this.authorizationBaseUrl}secure/access/role`);
  }

  getDataStreams() {
    return this.http.get<NewRole[]>(`${this.authorizationBaseUrl}secure/access/datastream`);
  }

  setApplicationDataStream(
    businessPartnerId: string,
    applicationKey: string,
    dataStreamKey: string,
  ) {
    return this.http.post(`${this.authorizationBaseUrl}secure/access/applicationdatastream`, {
      applicationKey,
      datastreamKey: dataStreamKey,
      entityExternalId: businessPartnerId,
      system: 'oneSAP',
    });
  }

  deleteApplicationDataStream(
    businessPartnerId: string,
    applicationKey: string,
    dataStreamKey: string,
  ) {
    const options = {
      headers: {},
      body: {
        applicationKey,
        datastreamKey: dataStreamKey,
        entityExternalId: businessPartnerId,
        system: 'oneSAP',
      },
    };
    return this.http.delete(
      `${this.authorizationBaseUrl}secure/access/applicationdatastream`,
      options,
    );
  }

  setUseraccess(profileId: number, applicationKey: string, roleKey: string) {
    return this.http.post(`${this.authorizationBaseUrl}secure/access/useraccess`, {
      profileId,
      applicationKey,
      roleKey,
    });
  }

  createNewApplication(newApplication: Application) {
    return this.http.post(`${this.authorizationBaseUrl}secure/access/application`, newApplication);
  }

  createNewApplicationGroup(newApplicationGroup: ApplicationGroup) {
    return this.http.post(
      `${this.authorizationBaseUrl}secure/access/application-group`,
      newApplicationGroup,
    );
  }

  deleteApplicationGroup(id: number) {
    const options = {
      headers: {},
      body: {
        id,
      },
    };

    return this.http.delete(
      `${this.authorizationBaseUrl}secure/access/application-group/`,
      options,
    );
  }

  deleteApplication(key: string) {
    const options = {
      headers: {},
      body: {
        key,
      },
    };

    return this.http.delete(`${this.authorizationBaseUrl}secure/access/application/`, options);
  }

  private getGroups(origin: string) {
    return this.http.get<ApplicationGroup[]>(
      `${this.authorizationBaseUrl}secure/access/application-group/${origin}`,
    );
  }
}
